<template>
  <div class="flex flex-col" :class="outerClass">
    <DateInput
      v-if="modifiedBindings"
      ref="input-ref"
      v-model="dob"
      :bindings="modifiedBindings"
      :maxDateByDays="maxDateByDays"
      :minDate="minDate"
      :dateMustBefore="dateMustBefore"
      :dateMustAfter="dateMustAfter"
    />
    <InformationBox
      v-if="invalidDobWarning && showinvalidDobWarning"
      :type="InformationBoxTypes.WARNING"
      :description="invalidDobWarning"
      class="mt-8 md:mt-6"
    />
  </div>
</template>
<script setup lang="ts">
import { VueFormInputProps } from '@/composables/useFormInputData';
import DateInput from './DateInput.vue';
import { onMounted, ref, computed, useTemplateRef } from 'vue';
import InformationBox from '../InformationBox/InformationBox.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import { useReferenceDataStore } from '@/store';
import { dateOfBirthIsValid } from '@/utils/formkit-helpers';

const props = defineProps<{
  bindings: VueFormInputProps;
  isPolicyholder?: boolean;
  isDriver?: boolean;
  invalidDobWarning?: string;
  maxDateByDays?: number;
  minDate?: string;
  dateMustBefore?: string;
  dateMustAfter?: string;
}>();

const minAge = ref<string | undefined>();
const dob = ref<string>();
const modifiedBindings = ref<any>();
const outerClass = ref<string>();

const inputRef = useTemplateRef('input-ref');

const refDataStore = useReferenceDataStore();

onMounted(async () => {
  // Fetch policyholder / driver min. age
  const configs = await refDataStore.getIQConfigSettings();
  if (props.isPolicyholder) {
    minAge.value = configs.find((c) => c.name == 'MinPolicyholderAge')?.value;
  } else if (props.isDriver) {
    minAge.value = configs.find((c) => c.name == 'MinDriverAge')?.value;
  }
  // fallback to default 16
  if (!minAge.value) minAge.value = '16';

  outerClass.value = props.bindings.outerClass;
  modifiedBindings.value = props.bindings;
  modifiedBindings.value.outerClass = '';
});

const showinvalidDobWarning = computed(() => {
  if (!dob.value) {
    return false;
  }
  if (!inputRef.value?.inputRef?.node || inputRef.value.inputRef.node?.context?.state?.invalid) {
    return false;
  }
  try {
    return !dateOfBirthIsValid(dob.value, Number(minAge.value));
  } catch (error) {
    console.error(error);
    return false;
  }
});
</script>
